"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentsHubResponseDto = exports.RemoveChatAttachmentDto = exports.DocumentsHubCountsDto = exports.DocumentsHubMilestoneGroupDto = exports.DocumentsHubVariationGroupDto = exports.DocumentsHubContractSectionDto = exports.DocumentsHubFileDto = exports.DocumentsHubTombstoneDto = void 0;
class DocumentsHubTombstoneDto {
    removedAt;
    removedByLabel;
}
exports.DocumentsHubTombstoneDto = DocumentsHubTombstoneDto;
class DocumentsHubFileDto {
    id;
    name;
    fileType;
    fileSize;
    kind;
    uploadedAt;
    uploadedByLabel;
    sourceLabel;
    milestoneId;
    /** Set only for chat-sourced entries — the Message this attachment lives on, needed to
     * target the remove-chat-attachment endpoint (removal is per-attachment, not per-document). */
    messageId;
    canRemove;
    removed;
    viewUrl;
    downloadUrl;
}
exports.DocumentsHubFileDto = DocumentsHubFileDto;
class DocumentsHubContractSectionDto {
    file;
    acceptedRevisionsCount;
}
exports.DocumentsHubContractSectionDto = DocumentsHubContractSectionDto;
class DocumentsHubVariationGroupDto {
    code;
    title;
    milestoneId;
    milestoneTag;
    files;
}
exports.DocumentsHubVariationGroupDto = DocumentsHubVariationGroupDto;
class DocumentsHubMilestoneGroupDto {
    milestoneId;
    label;
    seq;
    files;
}
exports.DocumentsHubMilestoneGroupDto = DocumentsHubMilestoneGroupDto;
class DocumentsHubCountsDto {
    all;
    photos;
    documents;
}
exports.DocumentsHubCountsDto = DocumentsHubCountsDto;
class RemoveChatAttachmentDto {
    url;
}
exports.RemoveChatAttachmentDto = RemoveChatAttachmentDto;
class DocumentsHubResponseDto {
    contract;
    supportingDocuments;
    variations;
    milestoneFiles;
    /** The client's own general (non-milestone) chat attachments. */
    sharedInChat;
    /** The business's own general (non-milestone) chat attachments. */
    businessSharedInChat;
    counts;
}
exports.DocumentsHubResponseDto = DocumentsHubResponseDto;
